import {useEffect, useState} from "react";
import moment from "moment";

import VLFModal from "@/components/Modal";
import VLFTextField from "@/components/Input/TextField";
import VLFSelectNew from "@/components/Input/SelectNew";

import {REQUIRED_FIELD, feeTypeOptions} from "@/utils/constants";
import {checkRequiredFields, playerToOption} from "@/utils/functions";

const requiredFields = ["player", "totalAmount", "feeType"];

function HandleFeeModal(props) {
	const {open, close, confirm, players} = props;

	const [formData, setFormData] = useState({
		feeType: feeTypeOptions[0],
		installmentsCount: 1,
	});
	const [errors, setErrors] = useState([]);

	useEffect(() => {
		if (!open) {
			setFormData({feeType: feeTypeOptions[0], installmentsCount: 1});
			setErrors([]);
		}
	}, [open]);

	const isInstallments = formData.feeType?.value === "installments";

	const handleConfirm = () => {
		const errs = checkRequiredFields(requiredFields, formData);
		setErrors(errs);
		if (errs.length) return;

		const totalAmount = parseFloat(formData.totalAmount) || 0;
		const count = isInstallments
			? parseInt(formData.installmentsCount) || 1
			: 1;
		const rateAmount = Math.round((totalAmount / count) * 100) / 100;

		const installments = [];
		for (let i = 0; i < count; i++) {
			installments.push({
				amount:
					i === count - 1 ? totalAmount - rateAmount * (count - 1) : rateAmount,
				dueDate: moment()
					.add(i + 1, "months")
					.startOf("month")
					.format("YYYY-MM-DD"),
				status: "unpaid",
				paymentMethod: null,
				paidDate: null,
			});
		}

		confirm({
			playerId: formData.player?.value,
			totalAmount,
			description:
				formData.description ||
				`Quota ${moment().year()}/${moment().year() + 1}`,
			installments,
		});
	};

	return (
		<VLFModal
			maxWidth="md"
			open={open}
			title="Nuova quota"
			close={close}
			confirm={handleConfirm}
			content={
				<div className="row">
					<div className="col-xs-12 col-sm-6">
						<VLFSelectNew
							options={players?.map((p) => playerToOption(p))}
							sortKey="sortKey"
							value={formData.player || ""}
							onChange={(value) => {
								setErrors([]);
								setFormData({...formData, player: value});
							}}
							label="Giocatore"
							required
							helperText={errors.indexOf("player") !== -1 ? REQUIRED_FIELD : ""}
							error={errors.indexOf("player") !== -1}
						/>
					</div>
					<div className="col-xs-12 col-sm-6">
						<VLFTextField
							name="totalAmount"
							value={formData.totalAmount || ""}
							onChange={(e) => {
								setErrors([]);
								setFormData({...formData, totalAmount: e.target.value});
							}}
							label="Importo totale (€)"
							size="small"
							type="number"
							required
							helperText={
								errors.indexOf("totalAmount") !== -1 ? REQUIRED_FIELD : ""
							}
							error={errors.indexOf("totalAmount") !== -1}
						/>
					</div>
					<div className="col-xs-12 col-sm-6">
						<VLFTextField
							name="description"
							value={formData.description || ""}
							onChange={(e) => {
								setFormData({...formData, description: e.target.value});
							}}
							label="Descrizione"
							size="small"
						/>
					</div>
					<div className="col-xs-12 col-sm-6">
						<VLFSelectNew
							options={feeTypeOptions}
							sorted={false}
							value={formData.feeType || feeTypeOptions[0]}
							onChange={(value) => {
								setErrors([]);
								setFormData({...formData, feeType: value});
							}}
							label="Tipo pagamento"
							required
							helperText={
								errors.indexOf("feeType") !== -1 ? REQUIRED_FIELD : ""
							}
							error={errors.indexOf("feeType") !== -1}
						/>
					</div>
					{isInstallments && (
						<div className="col-xs-12 col-sm-6">
							<VLFTextField
								name="installmentsCount"
								value={formData.installmentsCount || ""}
								onChange={(e) => {
									setFormData({...formData, installmentsCount: e.target.value});
								}}
								label="Numero rate"
								size="small"
								type="number"
							/>
						</div>
					)}
					{isInstallments &&
						formData.totalAmount &&
						formData.installmentsCount > 0 && (
							<div className="col-12">
								<div className="sec-note">
									{formData.installmentsCount}{" "}
									{formData.installmentsCount > 1 ? "rate" : "rata"} da{" "}
									<strong>
										{(
											Math.round(
												(parseFloat(formData.totalAmount) /
													parseInt(formData.installmentsCount)) *
													100,
											) / 100
										).toLocaleString("it-IT")}
										€
									</strong>{" "}
									con scadenza mensile
								</div>
							</div>
						)}
				</div>
			}
		/>
	);
}

export default HandleFeeModal;
